import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams, useHistory } from 'react-router-dom';

import { useQuery } from '../../utils/hooks/useQuery';
import { getImagePath } from '../../utils';

const MobileError = () => {

  const history = useHistory();
  const { client } = useParams()
  const query = useQuery()
  const logoImg = getImagePath('logo.png', client);

  const handleGoBack = () => {
    const returnUrl = query.get('return_url')
    if (returnUrl) {
      window.location.assign(returnUrl);
    } else {
      history.goBack()
    }
  }

  document.title = "Motorplay"

  return (
    <div className="App Cloudpay">
      <div className='Error_mobile'>
        <img src={logoImg} alt="logo" className='Error_image_logo' />
        <h1 className='Error_title'>
          <FormattedMessage id="MobileErrorComponent.description" />
        </h1>
        <button className='Error_back mt-3' onClick={handleGoBack}>
          <FormattedMessage id="ErrorComponent.buttons.back" />
        </button>
      </div>
    </div>
  );
};

export default MobileError;
